const autoNgTemplateLoaderTemplate1 = require('./container-restart-policy.html');

angular.module('shbdeployer.docker').component('containerRestartPolicy', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'ContainerRestartPolicyController',
  bindings: {
    name: '<',
    maximumRetryCount: '<',
    updateRestartPolicy: '&',
  },
});
